import {BaseDataBuilder} from './BaseDataBuilder'
import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {Builder} from '@wix/document-services-types'

export class NumberBuilder extends BaseDataBuilder {
    constructor(
        displayName: string,
        defaultValue: number,
        private minimum?: number,
        private maximum?: number,
        private multipleOf?: number
    ) {
        super('number', displayName, defaultValue)
    }

    toBuilderDataItem(): Builder.DataItem {
        return {
            ...super.toBuilderDataItem(),
            [DATA.DATA_TYPE.number]: {
                minimum: this.minimum,
                maximum: this.maximum,
                multipleOf: this.multipleOf
            }
        }
    }
}
